var varVideos = {};
varVideos.lastWidth = 0;
varVideos.lastHeight = 0;
varVideos.scrollTop = null;

$(document).ready(function()
{
  InitResizeVideos();
  InitScrollVideos();
});

// RESIZE
function InitResizeVideos()
{
  $(window).resize(function(){ ResizeVideos(); });
  document.addEventListener("webkitfullscreenchange",function(){ ResizeVideos(); }, false);
  window.onorientationchange = function(){ var orientation = window.orientation; ResizeVideos(); }
  ResizeVideos();
  setTimeout(function(){ ResizeVideos(); }, 500);
}
function ResizeVideos()
{
  varVideos.lastWidth = $(window).width();
  varVideos.lastHeight = $(window).height();
  
  CheckLoadingVideos();
}

// SCROLL
function InitScrollVideos()
{
  $(window).scroll(function(){
    varVideos.scrollTop = $(window).scrollTop();
    CheckLoadingVideos();
  });
  $(window).scroll();
}

function CheckLoadingVideos() {
  $('.section-lookbook-video, .homepage-video').each(function(i){
    $(this).find("video").each(function(j){
      var yVideo1 = ($(this).offset().top - varVideos.scrollTop - varVideos.lastHeight);
      var yVideo2 = yVideo1 + $(this).height() + varVideos.lastHeight;
      
      if (yVideo1 < 50 && yVideo2 > -50) {
        if ($(this).is(".toload") && $(this).is(":visible")) {
          $(this).removeClass("toload").attr("src", $(this).attr("data-src"));
        }
        if (!$(this).is(".toload") && !$(this).is(":visible")) {
          $(this).addClass("toload").attr("src", "");
        }
      } else if (!$(this).is(".toload")) {
        $(this).addClass("toload").attr("src", "");
      }
    });
  });
}